import { render, staticRenderFns } from "./RecentlyUsedAssets.vue?vue&type=template&id=3b1106cf&"
import script from "./RecentlyUsedAssets.vue?vue&type=script&lang=js&"
export * from "./RecentlyUsedAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports